import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.auth.SsoPanel', {
    xeroSigninText: 'Log in with',
    googleSigninText: 'Sign in with Google',
    xeroSignupText: 'Sign up with',
    googleSignupText: 'Sign up with Google',
    generalErrorMessage: 'Oops, something went wrong.',
});
